

module user {
  'use strict';

  export class LoginPageCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope','pageMetaService'
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: ILoginPageCtrlScope,
      private pageMetaService: navigation.IPageMetaService,
    ) {

      $scope.vm = this; 
      $scope.success = false;
      $scope.setProgress = <any>angular.bind(this, this.setProgress); //copy function to scope for directive //@TODO refactoring directive that it don't needs this coupling.      
      $scope.meta = pageMetaService.getPageMeta;
    }

    setProgress(bool: boolean) {
      this.$scope.requestOnGoing = bool;
    }

  }
};
